if (!customElements.get('apparel-carousel')) {
  customElements.define('apparel-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.te-apparel-carousel__track');
      this.cards = [...this.track.children];
      if (this.cards.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = !this.reduced.matches;
      this.visible = false;
      this.hovered = false;
      this.keyboardFocused = false;
      this.dragging = false;
      this.querySelector('.te-apparel-carousel__controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => { this.move(-1); this.scheduleRotation(); }, options);
      this.querySelector('[data-next]').addEventListener('click', () => { this.move(1); this.scheduleRotation(); }, options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovered = true; }, options);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') { this.hovered = false; this.scheduleRotation(); }
      }, options);
      this.addEventListener('focusin', event => { this.keyboardFocused = event.target.matches(':focus-visible'); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.keyboardFocused = false; this.scheduleRotation(); }
      }, options);
      this.addEventListener('pointerdown', () => { this.keyboardFocused = false; }, options);
      this.track.addEventListener('pointerdown', () => { this.dragging = true; }, options);
      const endDrag = () => { if (this.dragging) { this.dragging = false; this.scheduleRotation(); } };
      window.addEventListener('pointerup', endDrag, options);
      window.addEventListener('pointercancel', endDrag, options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1); this.scheduleRotation();
      }, options);
      this.track.addEventListener('scroll', () => this.updatePosition(), options);
      this.reduced.addEventListener('change', () => { this.playing = !this.reduced.matches; this.scheduleRotation(); }, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold: .25 });
      this.observer.observe(this.track);
      this.resize = new ResizeObserver(() => this.updatePosition());
      this.resize.observe(this.track);
      this.scheduleRotation();
      this.updatePosition();
    }
    scheduleRotation() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.playing && this.visible && !this.hovered && !this.keyboardFocused && !this.dragging && !document.hidden) this.move(1);
        this.scheduleRotation();
      }, 6000);
    }
    move(direction) {
      const step = this.cards[1].offsetLeft - this.cards[0].offsetLeft;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const current = this.track.scrollLeft;
      const groupSize = 3;
      const lastGroup = Math.floor((this.cards.length - 1) / groupSize) * groupSize;
      const lastPosition = Math.min(lastGroup * step, max);
      const currentGroup = Math.floor(Math.round(current / step) / groupSize);
      let next = (currentGroup + direction) * groupSize * step;
      if (direction > 0 && current >= lastPosition - 4) next = 0;
      if (direction < 0 && current <= 4) next = lastPosition;
      this.track.scrollTo({ left: Math.max(0, Math.min(next, max)), behavior: this.reduced.matches ? 'auto' : 'smooth' });
    }
    updatePosition() {
      const bounds = this.track.getBoundingClientRect();
      const visible = this.cards.map((card, index) => ({ index, rect: card.getBoundingClientRect() })).filter(item => item.rect.right > bounds.left + 20 && item.rect.left < bounds.right - 20);
      if (visible.length) this.querySelector('[data-position]').textContent = `${visible[0].index + 1}–${visible[visible.length - 1].index + 1} of ${this.cards.length}`;
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
    }
  });
}
